import brand from '@helpers/brand';
import styled, { css, keyframes } from 'styled-components';

const width = 10;
const size = 70;

const loadAnimation = keyframes`
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

const Loader = styled.div<{ theme?: 'black' | 'white' }>`
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation: ${loadAnimation} 1.1s infinite linear;
  border-radius: 50%;
  width: ${size}px;
  height: ${size}px;

  &:after {
    content: '';
    border-radius: 50%;
    width: ${size}px;
    height: ${size}px;
  }

  ${({ theme }) => {
    switch (theme) {
      case 'black':
      default:
        return css`
          border-top: ${width}px solid rgba(0, 0, 0, 0.1);
          border-right: ${width}px solid rgba(0, 0, 0, 0.1);
          border-bottom: ${width}px solid rgba(0, 0, 0, 0.1);
          border-left: ${width}px solid ${brand.nearlyBlack};
        `;

      case 'white':
        return css`
          border-top: ${width}px solid rgba(255, 255, 255, 0.3);
          border-right: ${width}px solid rgba(255, 255, 255, 0.3);
          border-bottom: ${width}px solid rgba(255, 255, 255, 0.3);
          border-left: ${width}px solid ${brand.white};
        `;
    }
  }}
`;

const Wrapper = styled.div``;

export const LoaderStyles = {
  Wrapper,
  Loader,
};
